import React from 'react';
import Violator from '@hpstellar/core/Violator/Violator.js';

//import '../css/product-segment-badge.less';


const ProductSegmentBadge = ({ product, className, size }) => {
    
    let segBadges = [];
    const { attributes={}, isSmb, rank={} } = product;
    if (rank.newest === 0) {
        segBadges.push('New!');
    }
    if (attributes.hasOwnProperty("energyeffcomp")) {
        segBadges.push('Energy Star');
    }
    if (isSmb === 'Yes') {
        segBadges.push('Business');
    }
    if(segBadges.length === 0){
        return null;
    }
    return <Violator value={segBadges} size={size} className={className} />;
};

export default React.memo(ProductSegmentBadge);
